import axios from "./_axios";
import { API } from "./apiEndPoints";

export const getChatterList = (account_id, record_id, type, page = 1) => {
  let result = axios()({
    method: "get",
    url: `${API.ACCOUNT_LIST_V2}${account_id}/chatter/?table=${type}&record_id=${record_id}`,
    params: { page: page },
  });
  return result;
};
